import React from 'react';
import classes from './OneClick.module.css';
import Button from '../../UI/Button/Button';
import UrlLink from '../../UI/UrlLink/UrlLink';
import CheckBox from '../../UI/CheckBox/CheckBox';
import Spinner from '../../UI/Spinner/Spinner';
import AlertError from '../AlertError/AlertError';
import strings from '../../../assets/localization';
import paths from '../../../constants/paths';

const OneClick = (props) => (
  <div className={classes.OneClick}>
    <div className={classes.OneClickInnerWrapper}>
      <div className={classes.HeaderWrapper}>
        <div className={classes.Header}>{strings.signInFromReferal}</div>
      </div>
      <div className={classes.Row}>
        <div className={classes.SubHeader}>{strings.siteWouldLikeToAccess}</div>
      </div>
      <div className={classes.Row}>
        <div className={classes.Permissions}>{strings.permissionsToAccess}</div>
      </div>
      <div className={classes.Row}>
        {props.isGDPR
          ? <div className={classes.CheckBox}>
            <CheckBox
              customCheckbox
              onClick={props.toggleCheckBox}
              checked={props.isChecked}
              labelStyles={{
                display: 'inline',
                fontSize: props.isLandscape ? '0.8rem' : '0.7rem',
                color: 'var(--secondary-color-text)'
              }}
            >
              {strings.iConsentToDetailsAndRegister}{' '}
              <UrlLink
                to={paths.TERMS_OF_SERVICE}
                style={{
                  display: 'inline',
                  textDecoration: 'underline',
                  fontSize: props.isLandscape ? '0.8rem' : '0.7rem'
                }}
                infotext
              >
                {strings.TermsOfService}{'.'}
              </UrlLink>
            </CheckBox>
          </div>
          : null}
      </div>
      <div className={classes.Row}>
        <div className={classes.ButtonWrapper}>
          {props.showSpinner
            ? <Spinner size='Tiny' />
            : <Button clicked={props.registerUser} disabled={props.isGDPR && !props.isChecked}>
              {strings.allow.toUpperCase()}
            </Button>}
        </div>
      </div>
      <div className={classes.Row}>
        <div className={classes.Footer}>
          <span className={classes.FooterText}>
            {strings.byClickingAllow}{' '}
            <span
              onClick={props.goToSignup}
              className={classes.Link}
            >
              {strings.standardRegistrationForm}{'.'}
            </span>
          </span>
        </div>
      </div>
    </div>
    {props.showError ? <AlertError dismissAlert={props.toggleAlertError} errorMessage={props.errorMessage} btnTxt={strings.Ok} /> : null}
  </div>
);

export default OneClick;
